import React from "react";
import { observer } from "mobx-react";
import { Button } from "@mui/material";
import { SaveIcon } from "../../../icons";
import { useRootStore } from "../../../store/contexts";

type GridExpressProps = {
  onClick: () => void;
  disabled?: boolean;
  label?: string;
};

export const ExportButton: React.FC<GridExpressProps> = observer(
  ({ onClick, disabled, label }) => {
    const rootStore = useRootStore();
    const { prefStore } = rootStore;

    return (
      <Button
        variant={"action"}
        size={prefStore.toolbarSize}
        disabled={disabled === undefined ? false : disabled}
        startIcon={<SaveIcon />}
        onClick={onClick}
      >
        {label === undefined ? "Exportar" : label}
      </Button>
    );
  }
);
